/**
 * Enumeration containing all possible types for charts or map
 */
export enum StatisticsType {
  /**
   * Represents bar chart
   */
  'chart.bar' = 'chart.bar',

  /**
   * Represents pie chart
   */
  'chart.pie' = 'chart.pie',

  /**
   * Represents line chart
   */
  'chart.line' = 'chart.line',
  /**
   * Represents map
   */
  'map' = 'map',
  /**
   * Represents table
   */
  'table' = 'table'
}
